import functions from "@/use/functions";
import axios from "axios";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export interface ErrorResponseData {
  message?: string;
  errors?: string[];
}

export function useApplicationDetails() {
  const applicationStore = useApplicationStore();
  const rootStore = useStore();
  const router = useRouter();

  async function moveToLoanService(confirmation: boolean) {
    if (confirmation) {
      functions.openModal({
        title: "Confirm",
        description:
          "Are you sure you want to move this application to Loan Service?",
        buttons: [
          { title: "Cancel", onClick: () => functions.closeModal() },
          { title: "Submit", onClick: () => moveToLoanService(false) },
        ],
      });
    } else {
      functions.closeModal();

      try {
        await axios.post(
          `/api/applications/${applicationStore.applicationId}/migrate`,
          {
            AuthorizedByUserId: rootStore.state.oidcStore.user?.sub,
            MigrateApplicationTargets: applicationStore.viewModel.id,
          },
          { headers: { "Content-Type": "application/json" } }
        );

        functions.openModal({
          title: "Success",
          description:
            "Application has been successfully moved to Loan Service",
          buttons: [
            {
              title: "Close",
              onClick: () => {
                functions.closeModal();
                // refresh the page
                router.go(0);
              },
            },
          ],
        });
      } catch (error) {
        console.error("Error moving application to loan service", error);

        const modal = {
          title: "Error",
          description:
            "There was an issue moving this application to Loan Service",
          html: "",
        };

        if (axios.isAxiosError(error)) {
          const data = error.response?.data as ErrorResponseData;

          if (data) {
            if (data.message) {
              modal.description = data.message;
            }
            if (data.errors?.length) {
              modal.html = `<ul>${data.errors
                .map((e: string) => `<li>${e}</li>`)
                .join("")}</ul>`;
            }
          } else {
            modal.description = error.message;
          }
        } else if (error instanceof Error) {
          modal.description = error.message;
        } else {
          modal.description = "An unknown error occurred";
        }
        functions.openModal(modal);
      }
    }
  }

  return {
    moveToLoanService,
  };
}
